import React from 'react';
import styles from './MobilePasswordCheck.module.scss';
import { Icon } from '../../../../engage/components/Icon';
import cx from 'classnames';

const MobilePasswordCheck = ({ isUpperCase, isLowerCase, isOneNumber, isSymbol, isMinLength }) => {
  return (
    <div className={styles.requiresContainer}>
      <ul className={cx(styles.erquirementsList)}>
        <li>
          <Icon
            src={isUpperCase ? 'requirementExists' : 'upperCase'}
            className={cx(styles.iconContainer, { [styles.exists]: isUpperCase })}
          />
          <span className={cx({ [styles.exists]: isUpperCase })}>Uppercase</span>
        </li>
        <li>
          <Icon
            src={isLowerCase ? 'requirementExists' : 'lowerCase'}
            className={cx(styles.iconContainer, { [styles.exists]: isLowerCase })}
          />
          <span className={cx({ [styles.exists]: isLowerCase })}>Lowercase</span>
        </li>
        <li>
          <Icon
            src={isOneNumber ? 'requirementExists' : 'number'}
            className={cx(styles.iconContainer, { [styles.exists]: isOneNumber })}
          />
          <span className={cx({ [styles.exists]: isOneNumber })}>Number</span>
        </li>
        <li>
          <Icon src={isSymbol ? 'requirementExists' : 'symbol'} className={cx(styles.iconContainer, { [styles.exists]: isSymbol })} />
          <span className={cx({ [styles.exists]: isSymbol })}>Symbol</span>
        </li>
        <li>
          <Icon
            src={isMinLength ? 'requirementExists' : 'passwordLength'}
            className={cx(styles.iconContainer, { [styles.exists]: isMinLength })}
          />
          <span className={cx({ [styles.exists]: isMinLength })}>Characters</span>
        </li>
      </ul>
    </div>
  );
};

export default MobilePasswordCheck;
